module.exports = __webpack_public_path__ + "static/media/masters_thesis24.e04f5e38.webp";